<template>
  <div class="examHome mx-2">
    <a-spin :spinning="isLoading">
	    <div class="exam-content container" v-if="user.business_id !== 213 || (user.business_id === 213 && [2536538, 2536537, 2536539].includes(user.id))">
		    <b-row class="pt-4 pb-1" align-h="between">
			    <b-col lg="3" sm="6" class="mb-2">
				    <b-input-group>
					    <b-input-group-prepend is-text>
						    <b-icon icon="search"></b-icon>
					    </b-input-group-prepend>
					    <b-input
							    style="border-left: none"
							    v-model="filterData.search"
							    :placeholder="$t('myExam.label.placeholder_search')"
							    @change="searchExams"
					    ></b-input>
				    </b-input-group>
			    </b-col>
			    <b-col lg="6" sm="6" class="p-0">
				    <b-row>
					    <b-col lg="6" sm="12" class="text-left mb-2 filterDropdown">
						    <!--              <label class="pr-3"> {{ $t("myExam.label.sort-to") }}</label>-->
						    <!--	            <b-form-select-->
						    <!--			            @change="sortExam"-->
						    <!--			            class="filter-dropdown"-->
						    <!--			            :options="sort"-->
						    <!--			            v-model="filterData.sort"-->
						    <!--	            >-->
						    <!--		            <template v-slot:first>-->
						    <!--			            <b-form-select-option :value="null">-->
						    <!--				            Latest-->
						    <!--			            </b-form-select-option>-->
						    <!--		            </template>-->
						    <!--	            </b-form-select>-->
					    </b-col>
					    <b-col lg="6" sm="12" class="text-left mb-2 filterDropdown">
                            <label class="pr-3">{{ $t("myExam.label.category") }}</label>
						    <b-form-select
								    @change="fillterExam"
								    class="filter-dropdown"
								    :options="categoryQuestion"
								    v-model="filterData.category"
						    >
                  <template v-slot:first>
                    <b-form-select-option :value="null">
                      {{ $t("teacher_list.option_default") }}
                    </b-form-select-option>
                  </template>
						    </b-form-select>
					    </b-col>
				    </b-row>
			    </b-col>
		    </b-row>
		    <h5 class="page-name1">{{ $t("myExam.title") }}</h5>
		    <b-row style="overflow: auto; height: 70vh">
                <b-col v-if="!isLoading && dummyData && dummyData.length === 0" cols="12">
                    <p class="text-muted text-center py-4" role="status">
                        {{ $t("myExam.label.empty") }}
                    </p>
                </b-col>
			    <b-col
					    lg="3"
					    sm="6"
					    v-for="fData in dummyData"
					    v-bind:key="fData.title"
					    class="pb-4"
			    >
				    <b-card
						    :img-src="fData.image_s3"
						    img-top
						    tag="article"
						    class="mb-2 card-exam"
				    >
					    <div class="d-flex justify-content-between align-items-center">
						    <div class=" card-title">
							    <span class=" pr-1" v-for="cate in fData.category">{{cate}}</span>
						    </div>
						    <b-button class="card-button1 card-button__action1"  @click="handleRenewal(fData)"  v-if="fData.time_to_play <= fData.time_to_play_of_student">
							    <span>{{$t("myExam.button.renewal")}}</span>
						    </b-button>
						    <b-button class="card-button1 card-button__action1" @click="handleDoExam(fData.id, fData.name)" v-if="fData.time_to_play > fData.time_to_play_of_student">
							    <span>{{ $t("myExam.button.test")}}</span>
						    </b-button>
					    </div>
					    <b-card-text class="pt-1">{{fData.name}}</b-card-text>
					    <b-row class="mb-1">
						    <b-col cols="8" class="card-author">{{ fData.created_by }}</b-col>
						    <b-col cols="4" class="text-right card-time">
							    {{ moment(fData.created_at).format("DD/MM/YYYY") }}
						    </b-col>
					    </b-row>
					    <div class="card-chart__myExam">
						    <b-badge class="card-bar"></b-badge>
						    <b-badge
								    class="card-bar card-bar-play__value"
								    :style="{ width: (fData.time_to_play_of_student / fData.time_to_play) * 100 + '%' }"
						    />
					    </div>
					    <div class="d-flex align-items-center justify-content-between">
						    <p class="timePlay">
							    {{ $t("myExam.label.timePlay") }}:<span class="pl-1"
						    >{{ fData.time_to_play_of_student }} / {{fData.time_to_play}}
                </span>
						    </p>
						    <div class="">
							    <b-button
									    class="card-button1 card-button__test1"
									    @click="handleViewResult(fData.id, fData.name)"
							    >
								    {{ $t("myExam.button.testResult") }}
							    </b-button>
						    </div>
					    </div>
				    </b-card>
			    </b-col>
		    </b-row>
            <div v-if="!isLoading && dummyData && dummyData.length > 0 && pagination && Number(pagination.total) > Number(pagination.per_page)" class="row py-3">
                <div class="col-12 col-md-8 d-flex align-items-center">
                    <div class="col-6 p-0 d-flex align-items-center">
                        <b-input
                            class="col-4 col-md-3 mr-1 mw-50"
                            type="number"
                            placeholder=""
                            @change="fillterExam"
                            v-model="filterData.selected.paginate"

                        >
                        </b-input>
                        bản ghi/Trang
                    </div>
                    <div class="col-6 p-0 d-flex align-items-center justify-content-end justify-content-lg-center">
                        Đến trang
                        <b-input
                            @change="fillterExam"
                            class="col-4 col-md-3 ml-1 mw-50"
                            type="number"
                            placeholder=""
                            v-model="filterData.page"

                        >
                        </b-input>

                    </div>
                </div>

                <div class="col-12 col-md-4 p-0">
                    <b-pagination
                        class="justify-content-end mt-2 pr-3"
                        :key="`${pagination.current_page}_${pagination.total}_${pagination.per_page}`"
                        @change="change"
                        :value="pagination.current_page"
                        :total-rows="pagination.total"
                        :per-page="pagination.per_page"
                        aria-controls="my-table"
                    ></b-pagination>
                </div>

            </div>

	    </div>
    </a-spin>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import router from "@/router";
import Cookies from "js-cookie";
export default {
  components: {},
  data() {
    return {
        isLoading: false,
        dummyData: null,
        pagination: null,
        categoryQuestion: [],
        filterData: {
		    search: "",
            perPage: 8,
            page: 1,
            category_id: "",
            category: null,
            selected: {
                paginate: 8,
            },
	    },
      sort: ["Completed" ,"Out of date"],
	    sortedExam:[]
    };
  },
  computed: {
    ...mapGetters({
	      user: "auth/user",
	      listCategories: "category/categoryb2c",
        getExamStudentRes:"student/getExamStudentResponse",
    }),

  },
	async created() {

    window.history.replaceState(null, null, window.location.pathname);
    Cookies.remove("idExam");
    Cookies.remove("typeExam")
		await this.fillterExam();
		await this.getCategory();
		for (let i = 0; i < this.listCategories.length; i++) {
			this.categoryQuestion.push({
				value: this.listCategories[i].id,
				text: this.listCategories[i].category,
			});
		};
	},
  mounted() {
  },
  updated() {

  },
  watch:{

  },
  methods: {
	  // sortExam(){
		// 	this.sortedExam = this.getExamStudentRes;
		//   console.log(this.filterData.sort)
		//   if(this.filterData.sort===null){
		// 	  console.log( (moment(this.sortedExam[0].updated_at).format('DD-MM-YYYY')) -  (moment(this.sortedExam[0].updated_at).format('DD-MM-YYYY')) )
		//   }
		//   console.log(this.sortedExam)
		//   this.dummyData = this.sortedExam;
	  // },
	  async fillterExam() {
		  this.isLoading= true;
		  await this.$store.dispatch("student/getListExamStudent", this.filterData);
		  this.isLoading= false;
          // console.log(this.getExamStudentRes);
          this.pagination = this.getExamStudentRes;
          this.dummyData = this.getExamStudentRes.data;

	  },
      searchExams(){
        this.filterData.page = 1;
        this.fillterExam();
      },
	  async getCategory() {
		  await this.$store.dispatch("category/getCategoryB2C");
	  },
	  moment,
	  handleViewResult(id, name) {
        Cookies.set("idExam", id);
        router.push(`/student/exam/my-exam/result?${name}`);
      },
	  handleDoExam(id, name){
			router.push(`/student/exam/try-exam?${id}&${name.replace(/ /g, "-")}`)
	  },
      handleRenewal(data){
          localStorage.setItem("exam-selected", JSON.stringify([data]));
          router.push("/student/exam/buy-exam");
      },
       change: function (page) {

		  this.filterData.page = page;
		  this.fillterExam();
	  },

  },
};
</script>

<style>
.row {
  margin: 0px !important;
}
.examHome{
	height: 92vh;
}
.page-name1 {
  font-weight: 700;
  padding-left: 15px !important;
  font-size: 15px;
  line-height: 150%;
  color: #0e2b5e;
}

.input-group-text {
  background-color: white;
}

.filter-dropdown {
  width: 57%;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  border: none;
  padding: 6px;
  margin-right: 1px;
}

.exam-content {
  margin-top: 15px;
  padding: 15px;
  border-radius: 15px;
  background-color: #fff;
}

.exam-content .row {
  margin-bottom: 20px;
}

.card-exam {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  border: none;
}

.card-exam img {
  border-radius: 10px 10px 0px 0px;
	border-top: 1px solid #e8e8e8;
	border-bottom: 1px solid #e8e8e8;
}

.card-title {
  font-weight: 700;
  font-size: 16px !important;
  line-height: 19px;
  color: #ffbf00;
  margin-bottom: 7px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 60%;
}

.card-body {
  padding: 7px 12px 13px 12px;
}

.card-time,
.card-text,
.card-author {
  font-size: 12px;
  line-height: 150%;
}

.card-text {
  padding-bottom: 8px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 20px !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.card-author {
  color: #0770ab;
  padding: 0px;
}

.card-time {
  padding: 0px;
  font-weight: 700;
  color: #f61717;
}

.card-chart__myExam {
  position: relative;
  height: 9px;
  margin-block: 7px;
}

.card-bar {
  display: block !important;
  position: absolute;
  width: 100%;
  padding: 4px 0px;
  background-color: #e5e5e5;
  border-radius: 0px !important;
}

.card-bar-play__value {
  background-color: #35b560 !important;
  box-shadow: inset -1px -1px 2px rgba(186, 205, 255, 0.47),
    inset 1px 1px 2px rgba(48, 70, 80, 0.24);
}

.card-button1 {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  border: none;
  text-align: center;
  height: 32px;
}

@media (max-width: 992px) {
  .card-button1 {
    font-size: 12px;
  }
	.filterDropdown{
		justify-content: space-between !important;
	}
	.examHome{
		margin-bottom: 10px;
		height: unset;
	}
}

.card-button__test1 {
  background-color: #35b560;
  height: 32px !important;
  font-size: 12px;
}

.card-button__action1 {
  background-color: #ffbf00;
  font-size: 12px;
}

.timePlay {
  padding: 0px;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: #0770ab;
}

.timePlay span {
  font-weight: 700;
  line-height: 150%;
}

.card-button__action1:hover {
  background-color: #edb300 !important;
  color: white !important;
}

.card-button__test1:hover {
  background-color: #2a924e !important;
  color: white !important;
}

.main-content {
  height: 100%;
}

@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1400px;
  }
}

.card-img-top{
	height: 175px;
	object-fit: contain;
}

.filterDropdown{
	display: flex;
	justify-content: flex-end;
	align-items: baseline;
}
.card-text{
    white-space: pre-wrap;
}
</style>
